import { GOOGLE_MAPS } from '../Constants'

export const openGoogleMaps = (searchTerm: string): void => {
  window.open(`${GOOGLE_MAPS}${searchTerm}`, '_blank')
}
